const [ w, d ] = [ window, document ]
import GET_ARTICLES from '../plugins/getArticles'

const init = () => {

  if( w.load['loadHtml'] ){
    w.load['loadHtml'].then( () => {
      // ナビゲーションカレント
      $('.nav-corporate[data-plugin="currentMenu"]').currentMenu({ mode: 0 });
    });
  }

  //スロット適用
  $.when( w.load['corporate-02'] ).then( ( html, slot ) => {
    let $obj = $( '[data-slot="corporate-outline-table"]' )
    slot ? $obj.replaceWith( slot ) : $obj.hide()
  });

  // SDGs宣言 活動報告
  $.when(w.load['corporate-03']).then( () => {
    let makeItem = item => {
      let itemBody =  item.body.replace(/(<([^>]+)>)/gi, '');

      let block = $(`<a href="${item.href}" class="sdgs-news-item">
        <figure class="sdgs-news-item__img">
          <img src="${item.thumb}" alt="${item.title}" loading="lazy">
        </figure>
        <div class="sdgs-news-item__body">
          <span class="date">${item.date}</span>
          <span class="subject">${item.title.str_truncate(24)}</span>
          <span class="body">${itemBody.str_truncate(24)}</span>
        </div>
      </a>`)[0];
      return block
    }

    GET_ARTICLES('.sdgs-news__list[data-plugin="getArticles"]', { makeItem });
  });
}

export default function CORPORATE() {
  $( init )
}